var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhydesign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 101,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#why_design_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_design_svg__b)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_design_svg__c)",
  fillRule: "evenodd",
  d: "M15.453 84.51c5.142.295 13.335.606 25.047.606s19.905-.31 25.047-.606c5.106-.293 9.259-3.792 9.742-8.598.37-3.68.711-9.04.711-16.296S75.66 47 75.29 43.32c-.484-4.808-4.637-8.306-9.743-8.599-5.142-.296-13.335-.606-25.047-.606s-19.905.31-25.047.606c-5.106.293-9.259 3.791-9.741 8.597C5.34 47.001 5 52.359 5 59.616c0 7.256.34 12.616.71 16.295.484 4.807 4.637 8.306 9.743 8.599",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_design_svg__d)",
  d: "M72.182 55.558c0-7.973-.135-13.78-.285-17.772-.195-5.203-4.283-9.252-9.47-9.444C57.734 28.168 50.554 28 40.384 28s-17.35.168-22.043.342c-5.187.192-9.275 4.241-9.47 9.444-.15 3.993-.285 9.8-.285 17.772s.135 13.779.285 17.772c.195 5.202 4.283 9.251 9.47 9.443 4.693.174 11.873.343 22.043.343s17.35-.17 22.043-.343c5.187-.192 9.275-4.24 9.47-9.443.15-3.993.285-9.8.285-17.772"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.4,
  d: "M29.078 83.039v-54.96c-4.476.064-8.023.163-10.737.264-5.187.192-9.275 4.24-9.47 9.443-.15 3.993-.285 9.8-.285 17.772 0 7.973.135 13.78.285 17.773.195 5.202 4.283 9.251 9.47 9.443 2.714.1 6.261.2 10.737.265"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M14.238 55.558c0 1.17 1.108 2.12 2.473 2.12h4.947c1.365 0 2.473-.95 2.473-2.12s-1.108-2.12-2.473-2.12H16.71c-1.365 0-2.473.95-2.473 2.12M14.238 45.665c0 1.17 1.108 2.12 2.473 2.12h4.947c1.365 0 2.473-.95 2.473-2.12s-1.108-2.12-2.473-2.12H16.71c-1.365 0-2.473.95-2.473 2.12M14.238 35.772c0 1.171 1.108 2.12 2.473 2.12h4.947c1.365 0 2.473-.949 2.473-2.12 0-1.17-1.108-2.12-2.473-2.12H16.71c-1.365 0-2.473.95-2.473 2.12",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_design_svg__e)",
  d: "M77.678 17.014c-1.472-.142-2.748.776-3.216 2.07-.704 1.946-2.022 6.017-2.365 10.136-.055.66.348 1.27.976 1.48 3.505 1.169 7.056 4.72 8.225 8.225.209.627.82 1.03 1.48.976 4.119-.343 8.19-1.661 10.136-2.365 1.294-.468 2.212-1.745 2.07-3.217-.415-4.286-2.665-8.397-5.787-11.519s-7.233-5.371-11.519-5.786"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_design_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.15,
  d: "M71.713 27.987c1.173-.077 2.354.075 3.415.58 1.339.637 3.271 1.738 4.916 3.384s2.747 3.578 3.384 4.917c.504 1.06.656 2.24.579 3.412-.278 4.23-.736 7.572-1.115 9.82-.43 2.546-2.307 4.521-4.721 5.23-6.437 1.89-11.637 3.034-15.237 3.707-1.8.336-3.2.555-4.155.69-.862.121-1.764.34-2.638.243-.814-.09-1.807-.45-2.737-1.38s-1.29-1.923-1.38-2.736c-.097-.874.122-1.777.244-2.639a96 96 0 0 1 .69-4.155c.672-3.6 1.817-8.8 3.706-15.236.709-2.415 2.684-4.291 5.23-4.721 2.248-.38 5.59-.839 9.82-1.116"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 0.2,
  d: "m71.72 28.087-.007-.1.007.1c1.16-.076 2.323.075 3.365.57 1.333.634 3.255 1.73 4.889 3.364 1.634 1.635 2.73 3.557 3.363 4.89.495 1.042.646 2.203.57 3.362-.277 4.226-.735 7.566-1.114 9.81-.423 2.507-2.27 4.452-4.65 5.151-6.433 1.889-11.63 3.032-15.227 3.704a96 96 0 0 1-4.151.69q-.299.043-.597.093c-.677.112-1.354.223-2.016.15-.793-.089-1.764-.439-2.677-1.352s-1.263-1.884-1.351-2.676c-.074-.663.037-1.34.149-2.017q.05-.298.094-.597a96 96 0 0 1 .689-4.15c.672-3.597 1.816-8.794 3.704-15.227.699-2.38 2.645-4.227 5.151-4.65 2.244-.38 5.583-.838 9.809-1.115Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M54.56 59.466a5 5 0 0 1-1.157-.876 5 5 0 0 1-.874-1.153L64.855 45.11a4.305 4.305 0 1 1 2.03 2.03z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_design_svg__c",
  x1: 26.117,
  x2: 69.275,
  y1: 37.274,
  y2: 84.005,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_design_svg__d",
  x1: 72.182,
  x2: -12.191,
  y1: 55.279,
  y2: 53.23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_design_svg__e",
  x1: 72.092,
  x2: 102.486,
  y1: 28.568,
  y2: 29.208,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_design_svg__b",
  width: 95,
  height: 75,
  x: -7,
  y: 22.116,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13700",
  stdDeviation: 6
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_design_svg__f",
  width: 40.025,
  height: 40.026,
  x: 48,
  y: 23.968,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13700"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13700",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.0941176 0 0 0 0 0.52549 0 0 0 0.36 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_20508_13700"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "why_design_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  y: 0.883,
  fill: "#fff",
  rx: 20
})))));
export { SvgWhydesign as ReactComponent };
export default __webpack_public_path__ + "static/media/why.design.92609ffe.svg";